import styled from "styled-components";
import { layout } from '../../../package.json';

export const Container = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  text-align: center;
  margin-bottom: 10px;
  span {
    font-size: 18px !important;
    color: black !important;
    font-weight: 300 !important;
  }
  p {
   color: black !important;
   font-size: 1rem;
   font-weight: 300 !important;
   margin-bottom: 5px;  
  }
   p + p {
    font-size: 1rem important;
   }

  @media (max-width: ${layout.tablet}) {
    p {
      font-size: 0.8rem;
    }
    span {
    font-size: 0.8rem !important;
    }
  }
`

export const ContainerChallenge = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  text-align: center;
  margin: 20px 0;

  p {
    color: #000;
    font-size: 1rem;
    font-weight: 400;
    max-width: 480px;
  }

  iframe {
    width: 100%;
    max-width: 480px;
    min-height: 450px;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  }

  @media (max-width: ${layout.tablet}) {
    p {
      font-size: 0.9rem;
    }
  }
`

export const ContainerConfirmation = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-bottom: 10px;
  gap: 15px;
  img {
    width: 57px;
    height: 57px;
  }
  span {
    font-size: 1.16rem !important;
    color: black !important;
    font-weight: 700 !important;
    font-style: bold;
  }
  p {
    font-size: 1.06rem !important;
    color: black !important;
    font-weight: 700 !important;
    font-style: bold;
  }
   p + p {
    max-width: 400px;
    font-size: 0.75rem !important;
    color: #707070 !important;
    white-space: normal;  
    overflow-wrap: break-word; 
    word-wrap: break-word; 
   }

  @media (max-width: ${layout.tablet}) {
    p {
      font-size: 0.9rem;
    }
    span {
    font-size: 0.8rem !important;
    }
    p + p {
      max-width: 80vw; 
    }
  }
`

export const ContainerCardCredit = styled.div`
  max-width: 100%;
  padding: 0 2%;
  display: flex;
  justify-content: center;
  h1 {
    color: #000;
  }
  > div {
    width: 100%;
    max-width: 23.12rem;

    > div {
      > div {
        width: 100%;
        max-width: 23.12rem;
        background: var(--primary) !important;
        .ReactCreditCard {
          width: 100%;
          max-width: 23.12rem;
        }
      }
    }
  }

  @media (max-width: ${layout.desktop}) {
    > div {
      margin: 0 auto;
      .ReactCreditCard {
          width: 100%;
          min-width: 100%;
      }
    }
  }
`;